import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { useAuthStore } from '@/app/shared/stores/auth-store';
import { navigationGuard } from '@okta/okta-vue';

export async function formLoginGuard(
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext
): Promise<void> {
  const authStore = useAuthStore();

  if (!authStore.shouldUseFormLogin) {
    return next();
  }

  if (
    !authStore.isAuthenticated &&
    !authStore.isInitializing &&
    !authStore.sessionRestoreAttempted
  ) {
    await authStore.restoreSession();
  }

  const isLoginPage = to.name === 'login';
  const isLogoutPage = to.name === 'Logout';
  const isAuthenticated = authStore.isAuthenticated;

  if (isLoginPage && isAuthenticated) {
    return next({ name: 'base-home' });
  } else if (isLogoutPage) {
    return next({ name: 'login' });
  } else if (!isLoginPage && !isAuthenticated) {
    return next({ name: 'login', query: { redirect: to.fullPath } });
  } else {
    return next();
  }
}

export async function oktaLoginGuard(
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext
): Promise<void> {
  const authStore = useAuthStore();

  if (!authStore.shouldUseOktaLogin) {
    return next();
  }

  const isLoginPage = to.name === 'login';

  if (isLoginPage) {
    return next({ name: 'base-home' });
  }

  try {
    const isAuthorized = await navigationGuard(to);
    if (isAuthorized) {
      return next();
    } else {
      return next(false);
    }
  } catch (error) {
    console.error('Okta navigation guard error:', error);
    return next(false);
  }
}
